var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.469 0.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.93,53.593H22.788A4.37,4.37,0,0,1,18.571,49.1V39.978H48.4v2.561a1.288,1.288,0,1,0,2.571,0V37.247h0V35.1a5,5,0,0,0-4.839-5.134H37.983a5,5,0,0,0-4.834-5.057H20.808A5,5,0,0,0,16,30.044v7.2h0V49.1a7.03,7.03,0,0,0,6.788,7.22H29.93a1.368,1.368,0,0,0,0-2.731ZM18.571,30.044a2.341,2.341,0,0,1,2.268-2.4H33.18a2.341,2.341,0,0,1,2.263,2.4,2.585,2.585,0,0,0,2.5,2.654h8.228A2.344,2.344,0,0,1,48.4,35.1v2.146H18.571ZM51.25,50.982a1.327,1.327,0,0,1-1.286,1.365H44.159v6.166a1.288,1.288,0,1,1-2.571,0V52.348H35.782a1.368,1.368,0,0,1,0-2.731h5.806V43.451a1.288,1.288,0,1,1,2.571,0v6.166h5.806A1.327,1.327,0,0,1,51.25,50.982Z",
    transform: "translate(-16 -24.91)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateFolderIcon);
export default __webpack_public_path__ + "static/media/create-folder-icon.4203c2db3ecf4d7898d293780c14a643.svg";
export { ForwardRef as ReactComponent };